<template>
<m-pageframe
    title="Search All Automated Messages"
>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px;"
>


    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="search_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="doUpdate()"
                >
                    <v-list-item-title>Refesh</v-list-item-title>
                </v-list-item>

                <v-divider/>

                <v-list-item
                    v-on:click="excelExport()"
                >
                    <v-list-item-title>Export (last 30 days)...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort

        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
            }"
    >

        <template v-slot:item.date="{ item }">
            {{$rc.pretty(item.at_time,'date')}}
        </template>

        <template v-slot:item.time="{ item }">
            {{$rc.pretty(item.at_time,'time')}}
        </template>

        <template v-slot:item.first_name="{ item }">
            {{prettyFirstName(item)}}
        </template>

        <template v-slot:item.last_name="{ item }">
            {{prettyLastName(item)}}
        </template>

        <template v-slot:item.send_to="{ item }">
            {{$rc.pretty(item.send_to)}}
        </template>

        <template v-slot:item.message="{ item }">
            {{prettyPreparedMessage(item)}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
                v-if="item.state != 'cancelled'"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    <v-list-item
                        v-if="item.state == 'ready-to-schedule' || item.state == 'scheduled'"
                        v-on:click="onClickCancel(item)"
                    >
                        <v-list-item-title>Cancel</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="item.message_params['url_view_in_crm'] != null"
                        v-on:click="onClickViewOrderInCommerce7(item)"
                    >
                        <v-list-item-title>View order in Commerce7...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-if="item.sent_stored_message_conversation_id != null"
                        v-on:click="onClickViewConversation(item)"
                    >
                        <v-list-item-title>View conversation...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickTemplateSettings(item)"
                    >
                        <v-list-item-title>Automated Message Settings: {{item.template_label}}...</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-if="item.state == 'ready-to-schedule'"
                        v-on:click="onClickSend(item)"
                    >
                        <v-list-item-title>Send...</v-list-item-title>
                    </v-list-item>

                    <v-divider/>

                    <v-list-item
                        v-on:click="onClickTechnicalDetail(item)"
                    >
                        <v-list-item-title>View technical details...</v-list-item-title>
                    </v-list-item>
                    
                </v-list>
            </v-menu>
        </template>

     </v-data-table> 
   
</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');

export default {
    data() {
        return {
            organization_label: null,
            template: null,
            search_text: null,
            results: null,
            param_variables: [],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {

        update: _.debounce(function()
        {
            this.doUpdate();
        },500),

        doUpdate()
        {
            let search = {
                'organization_id' : this.$route.params.organization_id,
                'full_text' : this.search_text,
                'sort' : 'at_time:desc'
            };

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/auto-messages',
            
                search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                    this.param_variables = data.param_variables;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to search auto messages');
                },
            );
        },

        prettyFirstName(item)
        {
            let params = item.message_params;
            return params['first-name'] ?? params.first_name ?? 'Unknown';
        },

        prettyLastName(item)
        {
            let params = item.message_params;
            return params['last-name'] ?? params.last_name ?? 'Unknown';
        },

        prettyPreparedMessage(item)
        {
            if ( item.prepared_message  == null )
                return '';

            return item.prepared_message.text ?? '';
        },

        onClickTemplateSettings(item)
        {
            this.$router.push({
                'name': 'auto-messages-template-settings',
                'params' : {
                    'organization_id' : item.organization_id,
                    'template_context' : item.template_context,
                    'template_subject_id': item.template_subject_id,
                }
            }).catch(e=>{}); // swallow any exception    
        },

        onClickSend(message)
        {
            this.$rc.showSpinner();
            
            this.$rc.sendAutoMessage(
                message.auto_message_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Message scheduled to be sent');
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to schedule message');
                },
            );
        },

        onClickViewOrderInCommerce7(message)
        {
            let url = message.message_params['url_view_in_crm'];

            window.open(url,"_blank");
        },

        onClickViewConversation(message)
        {
            this.$rc.toHomeForEndpoint(this.$router, message.scheduled_async_sent_from, false, message.sent_stored_message_conversation_id);
        },

        onClickCancel(message)
        {
            this.$rc.showSpinner();
            
            this.$rc.cancelAutoMessage(
                message.auto_message_id,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.doUpdate();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to cancel message');
                },
            );
        },

        onClickTechnicalDetail(item)
        {
            this.$rc.copy_code_dialog({
                'title': 'Automed Message Technical Details',
                'object': item,
            });
        },

        excelExport()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/auto-messages',
                    {
                        'organization_id': this.$route.params.organization_id,
                    }
                );
        },
    },

    computed: {
        headers() {
            var ret = [
                { text: 'By System', value: 'by_system'},
                { text: 'Date', value: 'date' },
                { text: 'Time', value: 'time' },
                { text: 'Message Type', value: 'template_label'},
            ];

            this.param_variables.forEach(
                (item) => {
                    ret.push({'text': item.column_label, 'value': item.column_id});
                }
            );

            ret = ret.concat([
                { text: 'Send To', value: 'send_to' },
                { text: 'Message', value: 'message' },
                { text: 'Status', value: 'state_desc' },
                { text: 'Action', value: 'action' },
            ]);

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>